import axios from "axios";
import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_STATS_REQUEST,
  PRODUCT_STATS_SUCCESS,
  PRODUCT_STATS_FAIL,
  PRODUCT_SINGLE_REQUEST,
  PRODUCT_SINGLE_SUCCESS,
  PRODUCT_SINGLE_FAIL,
  PRODUCT_PER_SERVICE_REQUEST,
  PRODUCT_PER_SERVICE_SUCCESS,
  PRODUCT_PER_SERVICE_FAIL,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
} from "constants/productConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import ProductsService from "services/products-service";

export const getProductList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_LIST_REQUEST,
    });

    const res = await ProductsService.getProducts();
    console.log("🚀 ~ file: productActions.js:23 ~ getProductList ~ res:", res);

    dispatch({
      type: PRODUCT_LIST_SUCCESS,
      payload: res.foundProducts,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: productActions.js:30 ~ getProductList ~ error:",
      error
    );
    dispatch({
      type: PRODUCT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getProductStats = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_STATS_REQUEST,
    });

    const res = await ProductsService.getProductsStats();
    console.log(
      "🚀 ~ file: productActions.js:23 ~ getProductStats ~ res:",
      res
    );

    dispatch({
      type: PRODUCT_STATS_SUCCESS,
      payload: res.result,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: productActions.js:30 ~ getProductStats ~ error:",
      error
    );
    dispatch({
      type: PRODUCT_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getSingleProduct = (productId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_SINGLE_REQUEST,
    });

    const res = await ProductsService.getProductSingle(productId);
    console.log(
      "🚀 ~ file: supplierActions.js:51 ~ getProductSingle ~ res:",
      res
    );

    dispatch({
      type: PRODUCT_SINGLE_SUCCESS,
      payload: res.foundProduct,
    });
  } catch (erroar) {
    console.log(
      "🚀 ~ file: productActions.js:98 ~ getSingleProduct ~ error:",
      error
    );
    dispatch({
      type: PRODUCT_SINGLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getProductPerServiceList =
  (serviceId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PRODUCT_PER_SERVICE_REQUEST,
      });

      const res = await ProductsService.getProductsPerService(serviceId);
      console.log(
        "🚀 ~ file: productActions.js:122 ~ getProductPerServiceList ~ res:",
        res
      );

      dispatch({
        type: PRODUCT_PER_SERVICE_SUCCESS,
        payload: res.foundServiceProducts,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: productActions.js:128 ~ getProductPerServiceList ~ error:",
        error
      );
      dispatch({
        type: PRODUCT_PER_SERVICE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const createProduct = (product) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CREATE_PRODUCT_REQUEST,
    });
    console.log("product create", product);

    const res = await ProductsService.createProducts(product);
    console.log("🚀 ~ file: productActions.js:119 ~ createProduct ~ res:", res);

    dispatch(getProductList());

    dispatch({
      type: CREATE_PRODUCT_SUCCESS,
      payload: res,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: productActions.js:126 ~ createProduct ~ error:",
      error
    );
    dispatch({
      type: CREATE_PRODUCT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const updateProduct =
  (productId, product) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_PRODUCT_REQUEST,
      });

      const res = await ProductsService.editProducts(productId, product);
      console.log("🚀 ~ file: productActions.js:145 ~ res:", res);

      dispatch(getSingleProduct(productId));
      dispatch(getProductList());

      dispatch({
        type: UPDATE_PRODUCT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: productActions.js:152 ~ error:", error);
      dispatch({
        type: UPDATE_PRODUCT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const deleteProduct = (productId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_PRODUCT_REQUEST,
    });

    const res = await axios.put(
      `${REACT_APP_API_URL}/admin/products/product/${productId}`
    );

    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: DELETE_PRODUCT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
